export default function ChangeProcedureConfirmDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  bcpDataService,
  loaderService,
  ssDialogService
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleConfirmChange = _handleConfirmChange;
  activate();

  /** *********************************************
   * Event Handlers
   */

  function activate() {
    vm.stringList = [];
    angular.forEach(
      vm.processes,
      (process) => {
        // eslint-disable-next-line max-len
        angular.forEach(
          process.assessmentFunctions,
          (eachFunction) => {
            // eslint-disable-next-line max-len
            const listName = `${process.name} - ${eachFunction.name}`;
            vm.stringList.push(listName);
          }
        );
      }
    );
  }

  function _handleCloseDialog($event) {
    _closeDialog($event);
    vm.dfdItem.resolve();
  }

  function _handleConfirmChange($event) {
    loaderService.showViewLoader = true;
    return bcpDataService.saveDocumentProcedure(vm.assessmentId, vm.processes)
      .then((processUpdated) => {
        alerts.success('The recovery procedures were successfully saved.');
        vm.dfdItem.resolve();

        $rootScope.$broadcast('refreshBCPAssessmentProcesses', { processes: processUpdated.data });

        // $rootScope.$broadcast('refreshRiskControls', { risk: vm.risk });
        _closeDialog($event);
      }).catch(() => {
        alerts.error('An error occurred while saving recovery procedure.');
        vm.dfdItem.reject();
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  /** *********************************************
   * Private Functions
   */

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.bcp.changeConfirmDialog);
  }
}

ChangeProcedureConfirmDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'bcpDataService',
  'loaderService',
  'ssDialogService'
];
